export default {
    secureDomain: "https://dhtmlxcode.com",
    version: "0.0.3",
    localBuildUrl: "",
    generation: `a${new Date().valueOf()}`,
};
